import { render, staticRenderFns } from "./AddArtistWizardStepFinished.vue?vue&type=template&id=c1140196&scoped=true&"
import script from "./AddArtistWizardStepFinished.vue?vue&type=script&lang=js&"
export * from "./AddArtistWizardStepFinished.vue?vue&type=script&lang=js&"
import style0 from "./AddArtistWizardStepFinished.vue?vue&type=style&index=0&id=c1140196&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1140196",
  null
  
)

export default component.exports